/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_Rules_Section_TitleInputs */

const en_directory_guide_rules_section_title = /** @type {(inputs: Directory_Guide_Rules_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we accept`)
};

const zh_directory_guide_rules_section_title = /** @type {(inputs: Directory_Guide_Rules_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录要求`)
};

/**
* | output |
* | --- |
* | "What we accept" |
*
* @param {Directory_Guide_Rules_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_rules_section_title = /** @type {((inputs?: Directory_Guide_Rules_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_Rules_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_rules_section_title(inputs)
	return zh_directory_guide_rules_section_title(inputs)
});
export { directory_guide_rules_section_title as "directory.guide.rules.section_title" }